import { GetAccountsResponse } from '@iwoca/lapi-client/edge';

import { useCurrentPayLink } from './useCurrentPayLink';
import { useGetAccounts } from '../../../api/lending/lapiHooks';
import { getDurationInMonths } from '../../utils/product';
import { selectLatestIwocaPayFormalOffer } from '../helpers/formalOffer';

export function useInterestRate() {
  const { payLink } = useCurrentPayLink();
  const { accounts } = useGetAccounts();

  if (!accounts) return null;

  const payLinkPricingInterest =
    getDurationFromLatestFormalOffer(accounts) === 12
      ? payLink?.product_pricing?.TWELVE_MONTHS?.representative_interest
      : payLink?.product_pricing?.THREE_MONTHS.representative_interest;

  if (payLinkPricingInterest === 0) {
    return 0;
  }

  const interestRate = getInterestRateFromLatestFormalOffer(accounts);

  return interestRate;
}

function getInterestRateFromLatestFormalOffer(
  accounts: GetAccountsResponse['data'],
) {
  if (!accounts) return null;

  const latestFormalOffer = selectLatestIwocaPayFormalOffer({ data: accounts });

  return latestFormalOffer?.interest_rates?.[0].rate || null;
}

function getDurationFromLatestFormalOffer(
  accounts: GetAccountsResponse['data'],
) {
  if (!accounts) return null;

  const latestFormalOffer = selectLatestIwocaPayFormalOffer({ data: accounts });

  if (!latestFormalOffer?.max_duration) return null;

  const durationInMonths = getDurationInMonths(latestFormalOffer?.max_duration);

  return durationInMonths;
}
